// extracted by mini-css-extract-plugin
export default {"row":"_7n+kp","data":"fepbb","row-cell":"TJLlo","rowCell":"TJLlo","table":"v5bNT","header":"nb5WB"};